import { HttpClient } from "@angular/common/http";
import { environment } from "#environments/environment";
import { Injectable } from "@angular/core";
import { Units } from "#models/units.model";
import { Observable } from "rxjs";

@Injectable()
export class UnitsService {
  constructor(private http: HttpClient) {}

  get(): Observable<Array<Units>> {
    return this.http.get<Array<Units>>(`${environment.apiEndpoint}/unit`);
  }

  post(payload: any): Observable<Units> {
    return this.http.post<Units>(`${environment.apiEndpoint}/unit`, payload);
  }

  put(payload: any): Observable<Units> {
    return this.http.put<Units>(
      `${environment.apiEndpoint}/unit/${payload.ID}`,
      payload
    );
  }
}
